<script setup lang="ts">
interface Props {
  item: { image?: string; alt?: string }
  index: number
  currentIndex: number
  eagerLoadFirstItem?: boolean
  sizes?: string
  isFullscreen?: boolean
  isNextItem?: boolean
  isPreviousItem?: boolean
  height?: number | string
  lastAction: string | null
}

const props = defineProps<Props>()

const loading = computed(() => {
  if (props.eagerLoadFirstItem) {
    return 'eager'
  }

  if (props.lastAction && (props.isNextItem || props.isPreviousItem)) {
    return 'eager'
  }

  return 'lazy'
})

const sizes = computed(() => {
  if (!props.isFullscreen && props.sizes) {
    return props.sizes
  }

  return '100vw lg:1200px'
})

const src = computed(() => {
  if (props.isFullscreen && props.index === props.currentIndex) {
    return props.item.image
  }

  if (props.isFullscreen && (props.isNextItem || props.isPreviousItem)) {
    return props.item.image
  }

  if (!props.isFullscreen) {
    return props.item.image
  }
})

const height = computed(() => {
  if (props.isFullscreen) {
    return undefined
  }

  return props.height
})
</script>

<template>
  <NuxtImg
    v-if="src"
    :height="height"
    class="object-cover w-full h-full select-none"
    :sizes="sizes"
    provider="twenty"
    format="webp"
    :data-src="item.image"
    :src="src"
    :alt="item.alt"
    :loading="loading"
  />
</template>
